// extracted by mini-css-extract-plugin
export default {"addToCartControl":"C0-z","giftCard":"D0-z","btnContainer":"E0-z","cartButton":"F0-z","disabled":"G0-z"};